import {EpLayer} from "./layer";
import {Style} from "ol/style";
import {LayerControl} from "../controls/LayerControl";
import TileLayer from "ol/layer/Tile";
import {TileWMS} from "ol/source";
import axios from "axios";
import {WMSCapabilities} from "ol/format";

export class EpBdlLayer extends EpLayer {
    constructor(map) {
        super(map);

        this.title = 'Bank danych o lasach';
        this.name = 'bdl';

        return this;
    }

    getSource() {
        if(this.source) {
            return this.source;
        }

        return this.generateSource();
    }

    generateSource() {
        return new TileWMS({
            url: 'https://mapserver.bdl.lasy.gov.pl/ArcGIS/services/WMS_BDL/mapserver/WMSServer?',
            params: {
                'LAYERS': (this.getLayers()).join(','),
                'STYLES': '',
                'TILED': true
            },
        });
    }

    getLayers() {
        const available = EpBdlLayer.getAvailableLayersSync();

        let layers = []
        for(const layer of available) {
            if (LayerControl.getLayerSavedVisibility(`bdl-${layer.Name}`) === 'true') {
                layers = [...layers, layer.Name]
            }
        }

        return layers;
    }

    /**
     * @returns {VectorLayer<VectorSourceType>}
     */
    getLayer() {
        if (!this.style) {
            this.style = new Style();
        }

        if (!this.layer) {
            let visible = (LayerControl.getLayerSavedVisibility(this.name) ?? 'true') === 'true';

            this.layer = new TileLayer({
                source: this.getSource(),
                style: this.style,
                visible,
                opacity: 0.4
            });
        }

        return this.layer;
    }

    async reload() {
        this.layer.setSource(this.generateSource());
    }

    static getAvailableLayersSync() {
        return JSON.parse(localStorage.getItem('bdl-layers') ?? '[]');
    }

    static hasAnyLayersInLocalStorage() {
        const layers = EpBdlLayer.getAvailableLayersSync();
        return layers.length;
    }

    static async saveAvailableLayersToLocalStorage() {
        const layers = [];

        try {
            const response = await axios.get(`https://mapserver.bdl.lasy.gov.pl/ArcGIS/services/WMS_BDL/mapserver/WMSServer?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetCapabilities`, {
                responseType: 'text'
            });

            const formatter = new WMSCapabilities();
            const data = formatter.read(response.data);

            const l = data.Capability.Layer;

            for(const layer of l.Layer) {
                layers.push(layer);
            }
        } catch(err) {
            console.log('Could not load BDL layers');
            return;
        }

        localStorage.setItem('bdl-layers', JSON.stringify(layers))

        return layers;
    }
}
